import React, { Component } from "react";

import ProjPeopleContent from "../../ProjPeopleContent";

import colors from "../../colors";

import Slider from "./Slider";

const projTeam = {
  header: [
    "Deputy Project Director",
    "Principal Investigator",
    "Co-investigators",
    "Team Lead",
    "Team Members",
    "Research Scientists",
    "Research Fellows",
  ],
  rows: {
    row1: [
      "Shri. P.V. Raju, Head, WRAD",
      "Sri. B. Simhadri Rao, S/E 'SG', WRAD, WRG",
      "Ms. Annie Maria Issac, S/E  'SD', WRAD, WRG",
      "",
      "",
      "Sri. Ankit Gupta  (RS&GIS)",
      "Smt. Sweta Shettenor SRF (WR)",
    ],
    row2: [
      "",
      "",
      "",
      "",
      "",
      "Dr. Nibedita Guru  (WR)",
      "Smt. Maheshwari Ruhi Akilesh SRF (RS&GIS)",
    ],
  },
};
export default class GProjTeam extends Component {
  render() {
    return (
      <div
        className="ui raised segment"
        style={{
          marginTop: "0em",
          padding: "0px",
          marginLeft: "20%",
          marginRight: "20%",
        }}
      >
        <div
          style={{
            paddingTop: "0px",
            paddingRight: "10px",
            paddingBottom: "10px",
            paddingLeft: "10px",
            backgroundColor: colors.background,
          }}
        >
          <Slider />
          {/* <MDBCard style={{ width: "100%", }}>
            <MDBCardBody> */}
          <main style={{ flexGrow: "1", overflowX: "auto" }}>
            <div className="card" style={{ width: "100%", height: "100%" }}>
              <div className="card-body">
                <ProjPeopleContent data={projTeam} width="80%" />
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }
}
